import Vue from 'vue'
import { visita as routing, pendencia } from '@/util/routes'

export default {
  state: {
    visita: {},
    visitas: [],
    paginateVisitas: {
      data: []
    },
    visitaPage: 1,
    visitaFilter: ''
  },
  mutations: {
    setVisita: (state, payload) => {
      state.visita = payload
    },
    setVisitas: (state, payload) => {
      state.visitas = payload
    },
    setPaginateVisitas: (state, payload) => {
      state.paginateVisitas = payload
    },
    setVisitaPage: (state, payload = 1) => {
      state.visitaPage = payload
    },
    setVisitaFilter: (state, payload = '') => {
      state.visitaFilter = payload
    }
  },
  actions: {
    async getPaginateVisitas ({ commit, state }, payload) {
      commit('setPaginateVisitas', {
        data: []
      })
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          page: state.visitaPage,
          filter: state.visitaFilter
        }
      })
      commit('setPaginateVisitas', data)
    },
    async getVisitas ({ commit }, payload) {
      commit('setVisitas', [])
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          limit: 0
        }
      })
      commit('setVisitas', data)
    },
    async getVisita ({ commit }, { id }) {
      commit('setVisita', {})
      const { data } = await Vue.axios.get(`${routing}/${id}`)
      commit('setVisita', data)
    },
    async postSaveVisita ({ state }) {
      const { visita } = state
      if (visita.id) {
        return Vue.axios.put(`${routing}/${visita.id}`, visita)
      }
      return Vue.axios.post(`${routing}`, visita)
    },
    async deleteVisita ({ state }) {
      const { visita } = state
      return Vue.axios.delete(`${routing}/${visita.id}`)
    },
    async getVisitasPendentes ({ commit, state }, payload) {
      commit('setVisitas', Object.assign({}, {}))
      const response = await Vue.axios.post(
        `${pendencia}/visitas`,
        {
          tecnico: state.onlyTecnico || payload
        }
      )
      commit('setVisitas', response.data)
    }
  },
  getters: {
    visitaPage: ({ visitaPage }) => visitaPage,
    visitaFilter: ({ visitaFilter }) => visitaFilter,
    visita: ({ visita }) => visita,
    visitas: ({ visitas }) => visitas,
    paginateVisitas: ({ paginateVisitas }) => paginateVisitas
  }
}
